import { Button, Modal, Stack, Text } from '@mantine/core';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useTranslation } from '@apple/lib/i18next';

import { storeEventQueries } from '@apple/features/store-events/queries';

export const Route = createFileRoute('/_authed/store-events/_steps/$storeEventId')({
	beforeLoad: async ({ context, params }) => {
		const storeEvent = await context.queryClient.fetchQuery(
			storeEventQueries.getById(params.storeEventId),
		);

		return { isStoreEventSubmitting: storeEvent.isSubmitting };
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { isStoreEventSubmitting } = Route.useRouteContext();
	const { t } = useTranslation('store-event');
	const navigate = Route.useNavigate();

	const handleClose = useCallback(() => {
		void navigate({
			to: '/store-events',
		});
	}, [navigate]);

	if (!isStoreEventSubmitting) {
		return <Outlet />;
	}

	return (
		<Modal
			opened={true}
			withCloseButton={false}
			closeOnClickOutside={false}
			closeOnEscape={false}
			onClose={handleClose}
			size='auto'
		>
			<Stack align='center' justify='center' px='lg' py='md'>
				<Text>{t('labels.eventNotEditable')}</Text>
				<Button onClick={handleClose}>{t('labels.backToStoreEvents')}</Button>
			</Stack>
		</Modal>
	);
}
